module.exports = __webpack_public_path__ + "assets/img/list_msg.8a17337a.svg";